import { WebchatSettings } from "./WebchatSettings";


export function applySettingsTheme(webchatSettings: WebchatSettings, parentHtmlElement?: HTMLElement | null) {
    if (!webchatSettings) webchatSettings = {};
    webchatSettings = { ...webchatSettings };

    let rootVarsContent = '';
    const settingToCssClassMap: { [key: string]: string | string[] } = {
        "bubbleColor": "--tc-webchat-launcher-bubble-color",
        "agentBubbleColor": "--tc-webchat-bot-bubble-bg",
        "agentBubbleTxtColor": "--tc-webchat-bot-bubble-text-color",
        "customerBubbleColor": "--tc-webchat-customer-bubble-bg",
        "customerBubbleTxtColor": "--tc-webchat-customer-bubble-text-color",
        "chatHeaderTxtColor": ["--tc-webchat-header-text-color", "--tc-webchat-header-icon-color"],
        "chatHeaderColor": "--tc-webchat-header-bg-color",
        "fontFamilyUrl": "--tc-webchat-font-family",
        "actionsColor": ["--tc-webchat-actions-bg-color", "--tc-webchat-actions-border-color", "--tc-webchat-qreplies-text-color", "--tc-webchat-qreplies-border-color"],
        "sideSpacing": "--tc-webchat-launcher-spacing-right",
        "bottomSpacing": "--tc-webchat-launcher-spacing-bottom"
    };

    const fontFamilyName = injectDynamicFont(webchatSettings.fontFamilyUrl);
    webchatSettings.fontFamilyUrl = fontFamilyName ? `"${fontFamilyName}"` : undefined;

    for (const [field, value] of Object.entries(webchatSettings)) {
        if (!(field in settingToCssClassMap) || !value) continue;
        const classes = settingToCssClassMap[field];
        const getValueSuffix = (fieldName: string) => ['sideSpacing', 'bottomSpacing'].includes(fieldName) ? 'px' : '';
        let newStyleRule = '';
        if (typeof classes === 'string') {
            newStyleRule = `${classes}: ${value}${getValueSuffix(field)};`;
        } else {
            newStyleRule = classes.reduce((result, c) => `${c}: ${value}${getValueSuffix(c)}; ${result}`, "");
        }
        rootVarsContent = `${newStyleRule} ${rootVarsContent}`;
    }
    injectCustomCss(`:root { ${rootVarsContent} }`, 'tc--custom-css-vars', parentHtmlElement);
    if (webchatSettings.customCssTheme) injectCustomCss(webchatSettings.customCssTheme, 'tc--custom-css-styles', parentHtmlElement);
}


export function injectDynamicFont(fontFamilyUrl: string | undefined): string | undefined {
    if (!fontFamilyUrl) return undefined;
    const fontName = getFontFamilyName(fontFamilyUrl);
    const fontLinkTagId = `${fontName}-link-tag`;
    const fontLinkTag = document.getElementById(fontLinkTagId);
    if (fontLinkTag) {
        fontLinkTag.setAttribute('href', fontFamilyUrl);
    } else {
        const newFontLinkTag = document.createElement('link');
        newFontLinkTag.id = fontLinkTagId;
        newFontLinkTag.href = fontFamilyUrl;
        newFontLinkTag.rel = "stylesheet";
        document.head.insertAdjacentElement('beforeend', newFontLinkTag);
    }
    return fontName;
}

export function injectCustomCss(cssText: string, styleTagId: string, parentElement?: HTMLElement | null) {
    if (!styleTagId) styleTagId = 'tc--custom-css-styles';
    const customCssStyleTag = document.getElementById(styleTagId);
    if (customCssStyleTag) {
        customCssStyleTag.innerHTML = cssText;
        return;
    }

    const customStyleTag = document.createElement('style');
    customStyleTag.id = styleTagId;
    customStyleTag.innerText = cssText;
    const parent = parentElement || document.head;
    parent.insertAdjacentElement('beforeend', customStyleTag);
}

export function getFontFamilyName(fontFamilyUrl: string) {
    try {
        const url = new URL(fontFamilyUrl);

        const familyUrlParam = url.searchParams.get('family');
        if (!familyUrlParam) {
            throw new Error('Missing family in font URL params');
        }

        const fontName = familyUrlParam.split(':')[0];
        if (!fontName) {
            throw new Error('Missing family name');
        }

        return fontName;
    } catch (error) {
        console.log({ error });
        return "Muli";
    }

}